export const SUCCESSFUL_STEP_UP_AUTH =
  "Great, you verified your info and have 20 minutes to make edits. If time expires, you'll have to verify your info again.";

export const SUCCESSFUL_PASSWORD_CHANGE = "Your password has been changed";

export const SUCCESSFUL_EMAIL_CHANGE = "Your personal email has been updated.";
